<div class="roles-dialog-wrapper">
    <div class="roles-dialog-header">
        <h2>{{ resourceConstant.rolesDescriptionTitle }}</h2>
        <button class="close-btn" (click)="dialogRef.close()">
            <rds-icon icon="close" namespace="outlined"></rds-icon>
        </button>
    </div>
    <div class="roles-dialog-body">
        <table rds-table [dataSource]="rolesData">
            <ng-container rdsColumnDef="role">
                <th rds-header-cell *rdsHeaderCellDef>Role</th>
                <td rds-cell *rdsCellDef="let element">
                    {{ element.role }}
                </td>
            </ng-container>

            <ng-container rdsColumnDef="description">
                <th rds-header-cell *rdsHeaderCellDef>Description</th>
                <td rds-cell *rdsCellDef="let element">
                    {{ element.description }}
                </td>
            </ng-container>

            <tr rds-header-row *rdsHeaderRowDef="displayedColumns"></tr>
            <tr rds-row *rdsRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>
</div>
